import {MainUtils} from '@/utils/main-utils';

export const SepaValidationErrorsUtils = {
  mixins: [
    MainUtils
  ],
  data () {
    return {
      sepaValidationErrors: {},
      showSepaValidationErrorsModal: false
    };
  },
  methods: {
    handleSepaValidationErrorResponse (error) {
      console.log(error, error.data);
      if (error && error.data) {
        this.sepaValidationErrors = this.getValidationErrors(error, false);
        this.showSepaValidationErrorsModal = true;
      } else {
        this.showErrorNotification(this.trans('general.couldNotDownloadSepa'));
      }
    }
  }
};
